export default __webpack_public_path__ + "static/media/Slotmachine4.00a3ab34.gif";